import { render, staticRenderFns } from "./dialog-positive.vue?vue&type=template&id=77dfded5&scoped=true&"
import script from "./dialog-positive.vue?vue&type=script&lang=js&"
export * from "./dialog-positive.vue?vue&type=script&lang=js&"
import style0 from "./dialog-positive.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./dialog-positive.vue?vue&type=style&index=1&id=77dfded5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dfded5",
  null
  
)

export default component.exports